import axios from 'axios'
import _get from 'lodash/get'

import { ERROR_MESSAGE_DELETING_FILE, ERROR_MESSAGE_DOWNLOADING_FILE, ERROR_MESSAGE_UPLOADING_FILE } from '../constants'
import { reportFileUploadError } from '../helpers/sentry'
import { truncateTextMiddle } from '../helpers/strings'
import { receiveSuccessAlert } from './alerts'
import { handleRequestError } from './request'

export const DELETE_USER_FILE = 'DELETE_USER_FILE'
export const DOWNLOAD_USER_FILE = 'DOWNLOAD_USER_FILE'
export const DOWNLOAD_USER_FILE_CONTENT = 'DOWNLOAD_USER_FILE_CONTENT'
export const RECEIVE_USER_FILES = 'RECEIVE_USER_FILES'
export const REMOVE_AND_DELETE_USER_FILE = 'REMOVE_AND_DELETE_USER_FILE'
export const REMOVE_USER_FILE = 'REMOVE_USER_FILE'
export const REQUEST_USER_FILES = 'REQUEST_USER_FILES'
export const UPLOAD_USER_FILE = 'UPLOAD_USER_FILE'

export const requestUserFiles = () => (dispatch) => {
    dispatch({ type: REQUEST_USER_FILES })

    axios
        .get('/userfile')
        .then((response) => {
            const data = _get(response, ['data'], [])
            dispatch(receiveUserFiles({ items: data, fetchSuccessful: true }))
        })
        .catch((error) => {
            if (_get(error, ['response', 'status']) === 404) {
                dispatch(receiveUserFiles({ fetchSuccessful: true }))
                return
            }

            dispatch(receiveUserFiles({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

export const receiveUserFiles = (data) => (dispatch) => {
    dispatch({ type: RECEIVE_USER_FILES, data })
}

export const uploadUserFile = (data) => (dispatch) => {
    dispatch({ type: UPLOAD_USER_FILE, data })

    const { fileType, identityVerificationId, file } = data

    const url = `/userfile?fileType=${fileType}&identityVerificationId=${identityVerificationId}`

    const formData = new FormData()
    formData.append('file', file)

    return axios
        .post(url, formData)
        .then(() => {
            const fileName = _get(file, ['name'])

            dispatch(receiveSuccessAlert(`File ${`"${truncateTextMiddle(fileName)}"`} successfully uploaded`))

            dispatch(requestUserFiles())
        })
        .catch((error) => {
            reportFileUploadError(error, file)
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_UPLOADING_FILE }))
            return Promise.reject(error)
        })
}

export const removeAndDeleteUserFile =
    (data, options = {}) =>
    (dispatch) => {
        dispatch({ type: REMOVE_AND_DELETE_USER_FILE, data })

        dispatch(removeUserFile(data))
        dispatch(deleteUserFile(data, options))
    }

export const removeUserFile =
    ({ id }) =>
    (dispatch, getState) => {
        dispatch({ type: REMOVE_USER_FILE, data: { id } })

        const { userFiles } = getState()

        const newData = userFiles.items.filter((e) => e.id !== id)

        dispatch(receiveUserFiles({ items: newData }))
    }

export const deleteUserFile =
    (data, { hideAlert = false } = {}) =>
    (dispatch) => {
        dispatch({ type: DELETE_USER_FILE, data })

        const { id, fileName } = data

        axios
            .delete(`/userfile/${id}`)
            .then(() => {
                dispatch(removeUserFile({ id }))

                if (!hideAlert) {
                    dispatch(receiveSuccessAlert(`File ${`"${truncateTextMiddle(fileName)}"`} deleted`))
                }
            })
            .catch((error) => {
                dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_DELETING_FILE }))
            })
    }

export const downloadUserFile = (data) => (dispatch) => {
    dispatch({ type: DOWNLOAD_USER_FILE, data })

    const { id } = data

    axios
        .get(`/userfile/${id}/downloadlink`)
        .then((response) => {
            if (response.data) {
                window.location.assign(response.data)
            }
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_DOWNLOADING_FILE }))
        })
}

export const downloadUserFileContent = (data) => (dispatch) => {
    dispatch({ type: DOWNLOAD_USER_FILE_CONTENT, data })

    const { id } = data

    return axios
        .get(`/userfile/${id}/filecontent`, {
            responseType: 'blob',
        })
        .then((response) => _get(response, ['data']))
        .catch((error) => {
            dispatch(handleRequestError(error))
            return Promise.reject(error)
        })
}
